<template>
  <v-app>
    <Header :menu="menu" />

    <v-content>
      <router-view @update="actualizar" />
    </v-content>

    <Footer />
  </v-app>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";

export default {
  name: "App",
  components: {
    Footer,
    Header
  },
  data: function() {
    return {
      menu: 0,
    };
  },
  methods: {
    actualizar(x) {
      this.menu = x;
    }
  },
};
</script>
